import axios from 'axios'

const state = {
  menuCount: null
}

const actions = {
  saveCustomer: async ({ commit }, submitData) => {
    const url = `/customers/${submitData.customer.id}`
    await axios.put(url, submitData)
    // console.log('res', res)
  }
}

const mutations = {}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
